import { CATEGORY_MODEL_KEY_POINTER } from 'models/daos/category/constants'

const CATEGORIES_DOMAIN = 'categories'
const CATEGORIES_STATE = {}

const CATEGORIES_DOMAIN_MAP_KEY = CATEGORY_MODEL_KEY_POINTER

export {
  CATEGORIES_DOMAIN,
  CATEGORIES_DOMAIN_MAP_KEY,
  CATEGORIES_STATE
}
